import BookingModel from 'uplisting-frontend/models/booking';
import CalendarModel from 'uplisting-frontend/models/calendar';
import MultiUnitModel from 'uplisting-frontend/models/multi-unit';

export enum UnavailabilitySource {
  bookingWindowRule = 'booking_window_rule',
  linkedListing = 'linked_listing',
  linkedUnavailability = 'linked_unavailability',
  partnerApi = 'partner_api',
  linkedPartnerApi = 'linked_partner_api',
  onboarded = 'onboarded',
}

export interface IUnavailabilitySchema {
  source: UnavailabilitySource;
  description: string;
  from: Date;
  to: Date;

  booking: BookingModel;
  calendar: CalendarModel;
  multiUnit: MultiUnitModel;
}
